export default "__VITE_ASSET__ClEjMnUm__"